import axiosInstance from './axiosConfig';
import { ApiResult } from './generalService';

export type TreatmentEffectParams = {
  planId?: string;
  treatmentId?: string;
  mode: 'default' | 'override';
  anchorDate: string;

  beforeStart: string;
  beforeEnd: string;
  afterStart: string;
  afterEnd: string;
};

export type EffectWindow = {
  startDate: string;
  endDate: string;
  totalDays: number;
  diaryDays: number;
  headacheDays: number;
  migraineDays: number;
  avgHeadacheDaysPerMonth: number;
  avgMigraineDaysPerMonth: number;
  coverage: number;
};

export type TreatmentEffectResponse = {
  planId: string;
  treatment?: { treatmentId: string };
  plan: {
    status: 'active' | 'stopped';
    anchorDate: string;
    anchorSource: 'patientConfirmedStartDate' | 'activatedAt';
  };
  mode: 'default' | 'override';
  windows: { before: EffectWindow; after: EffectWindow };
  derived: { migraineReductionPct: number; headacheReductionPct?: number };
  emrSummary: string;
};

export const fetchTreatmentEffect = (
  patientId: string,
  params: TreatmentEffectParams
) =>
  axiosInstance.get<ApiResult<TreatmentEffectResponse>>(
    `/treatment-effect/${patientId}`,
    { params }
  );
